import { createSelector } from 'reselect';
import { RootStore } from '../reducers/index';
import { ITermsConfigState } from '../reducers/termsConfigReducer';

const termsConfigStateSelector = createSelector(
  (state: RootStore) => state.termsConfig,
  (termsConfigState: ITermsConfigState) => termsConfigState,
);

export const termsCurrentStepSelector = createSelector(
  termsConfigStateSelector,
  (termsConfigState: ITermsConfigState) => termsConfigState.currentStep,
);

export const termsActiveSelector = createSelector(
  termsConfigStateSelector,
  (termsConfigState: ITermsConfigState) => termsConfigState.active,
);

export const termsAcceptanceSelector = createSelector(
  termsConfigStateSelector,
  (termsConfigState: ITermsConfigState) => termsConfigState.acceptance,
);

export const termsStepsSelector = createSelector(
  termsConfigStateSelector,
  (termsConfigState: ITermsConfigState) => termsConfigState.steps,
);
